<template>
  <v-container
    fluid
    pa-0
    ma-0
    class="test_red pl-3 pt-3 pb-3"
    style="max-width: 100vw"
  >
    <div class="container-home">
      <v-row no-gutters justify="start">
        <v-tabs
          id="containerv"
          :v-model="tab"
          :vertical="false"
          hide-slider
          :value="defaultTab"
          :show-arrows="true"
          :center-active="$vuetify.breakpoint.smAndDown"
        >
          <v-tab
            v-for="(item, index) in datas"
            :key="index"
            :value.sync="item.id.toString()"
            @click="scrollToBookmark(item.id.toString())"
          >
            <v-row justify="start" align="center" no-gutters class="test_blue">
              <span class="modal-name-details" v-text="item.name" />
            </v-row>
          </v-tab>
        </v-tabs>
      </v-row>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "CategoryBar",
  data: () => ({
    visible: true,
    selected: 0,
    tab: null,
    options: {
      duration: 1500,
      offset: 90,
      easing: "easeInOutCubic",
    },
  }),
  computed: {
    datas: function () {
      return this.$store.getters.storeMenu;
    },
    defaultTab: function () {
      return parseInt(this.$store.getters.selectedTab);
    },
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    scrollToBookmark(id) {
      this.$emit("handleTabSelect");
      const element = document.getElementById(id);
      const elementX = document.getElementById("tagbarid");
      const elementPosition = element.getBoundingClientRect().top;
      let staticHeight = 30;
      if (window.matchMedia("(min-width: 960px)").matches) {
        staticHeight = 0;
      }
      const offsetPosition =
        elementPosition - (elementX.offsetHeight + staticHeight);

      window.scrollBy({
        top: offsetPosition,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss">
.tag-tab {
  height: 24px; /* Set the height of the tab */
  line-height: 24px; /* Center the text vertically */
  padding: 0 8px; /* Add some padding */
  font-size: 14px; /* Set the font size */
  border-radius: 12px; /* Make the corners rounded */
  background-color: #ffffff; /* Set the background color */
  color: #333333; /* Set the text color */
  cursor: pointer; /* Change the cursor to a pointer on hover */
  margin-right: 8px; /* Add some space between the tabs */
}

.checkout-container {
  border-bottom: solid !important;
  border-width: 1px !important;
  border-color: rgba($color: #afafaf, $alpha: 0.5) !important;
}
.container-home {
  max-width: 1400px !important;
  margin: 0 auto;
}
.p-color {
  color: var(--v-primary-base) !important;
}
@media screen and (max-width: 960px) {
  .container-home {
    max-width: none !important;
    //padding: 0 30px !important;
  }
}
</style>
